import ca from 'date-format-parse/lib/locale/ca'
import cs from 'date-format-parse/lib/locale/cs'
import de from 'date-format-parse/lib/locale/de'
import en from 'date-format-parse/lib/locale/en'
import es from 'date-format-parse/lib/locale/es'
import fr from 'date-format-parse/lib/locale/fr'
import it from 'date-format-parse/lib/locale/it'
import ko from 'date-format-parse/lib/locale/ko'
import nl from 'date-format-parse/lib/locale/nl'
import pl from 'date-format-parse/lib/locale/pl'
import pt from 'date-format-parse/lib/locale/pt'
import ro from 'date-format-parse/lib/locale/ro'
import ru from 'date-format-parse/lib/locale/ru'
import sl from 'date-format-parse/lib/locale/sl'
import sr from 'date-format-parse/lib/locale/sr'
import tr from 'date-format-parse/lib/locale/tr'
import zhCN from 'date-format-parse/lib/locale/zh-cn'

export const DAYS_OF_WEEK = 7
export const DAY_OF_WEEK_SATURDAY = 6
export const DAY_OF_WEEK_SUNDAY = 0
export const MONTH_NUMBER_FORMAT = 'MM'
export const WEEK_NUMBER_FORMAT = 'WW'
export const MONTH_STRING_SHORT_FORMAT = 'MMM'
export const MONTHS_OF_YEAR = 12
export const SECONDS_IN_HOUR = 3600
export const SECONDS_IN_MINUTE = 60
export const DATE_FORMAT = 'L'                                  // 13/09/2018
export const DATE_SIMPLE_FORMAT = 'D/M/YY'                      // 13/9/18
export const DATETIME_FORMAT = 'L LTS'                          // 13/09/2018 08:30:00
export const DAY_MONTH_STRING_SHORT_FORMAT = 'DD MMM'           // 01 Sep.
export const HOUR_STRING_FORMAT = 'HH:mm'                       // 08:30
export const DATE_HOUR_STRING_FORMAT = 'L HH:mm'                // 13/09/2018 08:30
export const TIME_STRING_FORMAT = 'HH:mm::ss'                   // 08:30:59
export const ISO_DATE_FORMAT = 'YYYY-MM-DD'                     // 2018-09-13
export const ISO_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]'     // 2018-09-13T08:30:00Z
export const MONTH_YEAR_STRING_SHORT_FORMAT = 'MMM YYYY'        // Sep. 2022
export const NATURAL_DATE_FORMAT = 'LL'                         // 13 September 2018
export const NATURAL_DATE_FORMAT_MIN = 'MMM-YY'                 // Sep - 18
export const NATURAL_DATE_FORMAT_SHORT = 'll'                   // 13 Sep 2018
export const NATURAL_DATETIME_FORMAT = 'LL LTS'                 // 13 September 2018 08:30:00
export const NATURAL_NAME_DATETIME_FORMAT = 'dddd, D MMMM YYYY' // Wednesday, September 2018
export const NATURAL_SHORT_WITH_HOUR = 'D MMM LT'               // 13 Sep 9:17
export const NATURAL_SHORT_WITH_HOUR_AND_YEAR = 'D MMM YYYY LT' // 13 Sep 2018 9:17
export const NATURAL_SHORTER_NAME_DATETIME_FORMAT = 'ddd, D MMM YYYY' // Wed, 13 Sep 2018
export const UNAWARE_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'    // 2018-09-13 08:30:00

export const EMPTY_DATE = '--/--/----'

export const DATE_PICKER_LANGUAGES = {
  'ca': {
    formatLocale: ca,
  },
  'cs': {
    formatLocale: cs,
  },
  'de': {
    formatLocale: de,
  },
  'en': {
    formatLocale: en,
  },
  'es': {
    formatLocale: es,
  },
  'fr': {
    formatLocale: fr,
  },
  'it': {
    formatLocale: it,
  },
  'ko': {
    formatLocale: ko,
  },
  'nl': {
    formatLocale: nl,
  },
  'pl': {
    formatLocale: pl,
  },
  'pt': {
    formatLocale: pt,
  },
  'ro': {
    formatLocale: ro,
  },
  'ru': {
    formatLocale: ru,
  },
  'sk': {
    formatLocale: sl,
  },
  'sr': {
    formatLocale: sr,
  },
  'tr': {
    formatLocale: tr,
  },
  'zh': {
    formatLocale: zhCN,
    yearFormat: 'YYYY年',
    monthBeforeYear: false,
  },
}
export const SERVER_WEEK_DAYS_VALUES = {
  MONDAY: 0,
  TUESDAY: 1,
  WEDNESDAY: 2,
  THURSDAY: 3,
  FRIDAY: 4,
  SATURDAY: 5,
  SUNDAY: 6,
}
